(function () {
  'use strict';

  // Everything below uses event delegation on `document` rather than binding
  // listeners to individual elements at init time. That makes it robust
  // against script load order, the Shopify theme editor re-rendering
  // sections, and blocks/products being added later — there's nothing to
  // re-initialize.

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function showModal(message) {
    var modal = qs('[data-stl-modal]');
    if (!modal) return;
    var msgEl = qs('[data-stl-modal-message]', modal);
    if (msgEl && message) msgEl.textContent = message;
    modal.hidden = false;
  }

  function hideModal() {
    var modal = qs('[data-stl-modal]');
    if (modal) modal.hidden = true;
  }

  function showToast(message) {
    var toast = qs('.stl-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'stl-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.setAttribute('data-visible', 'true');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.setAttribute('data-visible', 'false');
    }, 2500);
  }

  function refreshCartUI(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));

    var drawer = document.querySelector('cart-drawer, cart-notification, .cart-drawer, #cart-drawer, #CartDrawer');
    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      if (typeof drawer.renderContents === 'function') {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (fullCart) { drawer.renderContents(fullCart); });
        return;
      }
      drawer.classList.add('is-open', 'active', 'drawer--is-open');
    }

    if (cart && typeof cart.item_count !== 'undefined') {
      qsa('[data-cart-count], .cart-count-bubble, #cart-icon-bubble').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var message = (data && data.description) || 'Something went wrong adding this to your bag.';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Groups the look photos by their current visual row (based on rendered
  // position, so it's correct at any breakpoint/column count) and returns
  // the last button in the same row as `button` — i.e. where the panel
  // needs to be inserted so it lands directly under that row.
  function findLastButtonInSameRow(button, allButtons) {
    var targetTop = Math.round(button.getBoundingClientRect().top);
    var sameRow = allButtons.filter(function (b) {
      return Math.round(b.getBoundingClientRect().top) === targetTop;
    });
    return sameRow[sameRow.length - 1] || button;
  }

  function closePanel(toggle, panel) {
    panel.classList.remove('is-open');
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function handleLookToggle(toggle) {
    var section = toggle.closest('[data-section-type="shop-the-look"]');
    if (!section) return;
    var grid = qs('.stl-look-grid', section);
    var lookId = toggle.getAttribute('data-look-id');
    var panel = qs('[data-look-panel="' + lookId + '"]', section);
    if (!panel || !grid) return;

    var allToggles = qsa('[data-look-toggle]', section);
    var wasOpen = panel.classList.contains('is-open');

    // Accordion: close every look's panel first (this also removes any
    // panel currently sitting inside the grid from a previous click).
    allToggles.forEach(function (t) {
      var otherId = t.getAttribute('data-look-id');
      var otherPanel = qs('[data-look-panel="' + otherId + '"]', section);
      if (otherPanel) closePanel(t, otherPanel);
    });

    if (wasOpen) return; // it was open — the loop above just closed it.

    // Insert the panel directly after the last photo in this look's row,
    // so it renders underneath that row instead of at the end of the grid.
    var lastInRow = findLastButtonInSameRow(toggle, allToggles);
    lastInRow.insertAdjacentElement('afterend', panel);

    panel.hidden = false;
    panel.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');

    if (typeof panel.scrollIntoView === 'function') {
      setTimeout(function () {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 50);
    }
  }

  function handleSizeSelect(btn) {
    if (btn.classList.contains('is-soldout') || btn.hasAttribute('disabled')) return;
    var productEl = btn.closest('[data-stl-product]');
    if (!productEl) return;
    qsa('.stl-size-link', productEl).forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    productEl.setAttribute('data-selected-variant-id', btn.getAttribute('data-variant-id'));
  }

  function handleAddToBag(btn) {
    var productEl = btn.closest('[data-stl-product]');
    if (!productEl) return;
    var variantId = productEl.getAttribute('data-selected-variant-id');
    if (!variantId) {
      showModal('Please select a size first.');
      return;
    }
    var originalLabel = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    addItems([{ id: variantId, quantity: 1 }])
      .then(function () {
        btn.setAttribute('data-state', 'added');
        btn.textContent = 'Added';
        showToast('Added to your bag');
        return getCart();
      })
      .then(function (cart) {
        refreshCartUI(cart);
        setTimeout(function () {
          btn.removeAttribute('data-state');
          btn.textContent = originalLabel;
          btn.removeAttribute('disabled');
        }, 1800);
      })
      .catch(function (err) {
        btn.removeAttribute('disabled');
        showModal(err.message || "This item can't be added to your bag");
      });
  }

  function handleAddAll(btn) {
    var lookId = btn.getAttribute('data-look-id');
    var section = btn.closest('[data-section-type="shop-the-look"]');
    if (!section) return;
    var look = qs('[data-look-panel="' + lookId + '"]', section);
    if (!look) return;

    var products = qsa('[data-stl-product]', look);
    var missing = products.some(function (p) { return !p.getAttribute('data-selected-variant-id'); });
    if (missing) {
      showModal('Please select a size for every item before adding all to your bag.');
      return;
    }

    var items = products.map(function (p) {
      return { id: p.getAttribute('data-selected-variant-id'), quantity: 1 };
    });

    btn.setAttribute('disabled', 'disabled');
    addItems(items)
      .then(function () {
        showToast('Added ' + items.length + ' items to your bag');
        return getCart();
      })
      .then(function (cart) {
        refreshCartUI(cart);
        btn.removeAttribute('disabled');
      })
      .catch(function (err) {
        btn.removeAttribute('disabled');
        showModal(err.message || "These items can't be added to your bag");
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var modalClose = target.closest('[data-stl-modal-close]');
    if (modalClose) {
      hideModal();
      return;
    }

    var toggle = target.closest('[data-look-toggle]');
    if (toggle) {
      if (toggle.hasAttribute('disabled')) return;
      event.preventDefault();
      handleLookToggle(toggle);
      return;
    }

    var sizeBtn = target.closest('.stl-size-link');
    if (sizeBtn) {
      event.preventDefault();
      handleSizeSelect(sizeBtn);
      return;
    }

    var addBtn = target.closest('[data-add-to-bag]');
    if (addBtn) {
      if (addBtn.hasAttribute('disabled')) return;
      event.preventDefault();
      handleAddToBag(addBtn);
      return;
    }

    var addAllBtn = target.closest('[data-add-all]');
    if (addAllBtn) {
      if (addAllBtn.hasAttribute('disabled')) return;
      event.preventDefault();
      handleAddAll(addAllBtn);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideModal();
  });
})();